<template>
    <el-dialog :visible.sync="openDialog" :append-to-body="true" class="newDialog" width="600px" title="审核" :close-on-click-modal="false">
        <el-form label-width="100px" ref="form" :model="form" :rules="rules" size="small">
            <el-form-item label="审批意见" prop="auditRemark">
                <el-input
                    type="textarea"
                    size="small"
                    :rows="5"
                    placeholder="请输入内容"
                    v-model="form.auditRemark">
                </el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="openDialog = false" size="small">取 消</el-button>
            <el-button type="primary" @click="submitAudit(0)" size="small">驳回</el-button>
            <el-button type="primary" @click="submitAudit(1)" size="small">同意</el-button>
        </span>
    </el-dialog>
</template>

<script>
import {auditOrder } from '@/api/srm/inquiryDetail.js'
export default {
    props: [],
    data() {
        return {
            // 审核
            openDialog:false,
            form:{
                id:'',
                auditRemark:'',
            },
            rules:{
                auditRemark:[{ required: true, message: '请输入审批意见', trigger: 'blur' }],
            },
        };
    },
    computed:{
    },
    created() {

    },
    mounted() {

    },
    methods: {
        auditOpen(row){
            this.form={
                id:row.id,
                auditRemark:'',
            };
            if (this.$refs["form"] !== undefined) {
				this.$refs["form"].resetFields();
			}
            this.openDialog = true;
        },
        submitAudit(type){
            let _this = this;
			_this.$refs['form'].validate((valid) => {
                if (valid) {
                    let pramar = {..._this.form};
                    if(type){   // 同意
                        pramar['auditStatus'] = 3;
                    }else{  // 驳回
                        pramar['auditStatus'] = 2;
                    }
                    console.log(pramar)
                    auditOrder(pramar).then((response)=>{
                         if (response.data.code === 0) {
                            _this.$success(response.data.msg);
                            _this.openDialog = false;
                            _this.$emit('callback',{type:'updateInfo'})
                        }
                    })
                }
            })
        },
    },
};
</script>

<style lang="scss">

</style>
